export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "step": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Step"])}
      },
      "fr": {
        "step": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Étape"])}
      }
    }
  })
}
